import React, { Component } from 'react'
import Header from '../Header'
import './XXXIVs.css'

class XXXIVs extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyXXXIVs">
                    <p className="textXXXIV">2028, Los Angeles, Etats-Unis, 21 juillet - 6 août. A venir</p>
                </div>
            </div>
        )
    }
}

export default XXXIVs